<template>
  <div class="relative">
    <input :id="id" :name="id" :type="isShown ? 'text' : 'password'" :autocomplete="autocomplete" :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)" :disabled="disabled"
      class="w-full h-10 sm:h-9 text-[16px] sm:text-sm" :class="{ 'pr-10': toggle, 'input-not-validated': invalid }" :aria-invalid="invalid || null">
    <button v-if="toggle" type="button" class="bn-icon-only absolute right-1 top-1/2 -translate-y-1/2"
      :aria-label="isShown ? 'Hide password' : 'Show password'" :aria-pressed="isShown" @click="flip">
      <EyeOffIcon v-if="isShown" />
      <EyeIcon v-else />
    </button>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { EyeIcon, EyeOffIcon } from '@heroicons/vue/solid'

// A password input with an optional show/hide eye. A parent that binds v-model:shown controls it (one eye for two
// fields); otherwise the field keeps its own state. A parent's .trim on v-model is applied by Vue.
export default {
  name: 'PasswordField',
  components: { EyeIcon, EyeOffIcon },
  props: {
    modelValue: { type: String, default: '' },
    id: { type: String, required: true },
    autocomplete: { type: String, required: true },
    invalid: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    toggle: { type: Boolean, default: true },
    shown: { type: Boolean, default: undefined }
  },
  emits: ['update:modelValue', 'update:shown'],
  setup(props, { emit }) {

  // Refs
    const ownShown = ref(false)

  // Computed
    const isShown = computed(() => props.shown === undefined ? ownShown.value : props.shown)

  // Handlers
    const flip = () => {
      const next = !isShown.value
      ownShown.value = next
      emit('update:shown', next)
    }

    return { isShown, flip }
  }
}
</script>
